

export const getNonAlcoholLabel = (seat) => {
  const homeTeamSlug = (seat && seat.gameDetails && seat.gameDetails.homeTeamSlug) || (seat && seat.homeTeamSlug) || "";
  switch (homeTeamSlug) {
    case "calgary-stampeders": {
      const isNonAlcoholZone = seat.zone === 'Lower Zone L';
      return isNonAlcoholZone ? " (Family Zone - No Alcohol)" : '';
    }

    case "edmonton-elks": {
      const nonAlcoholZones = ["Lower Zone AA", "Lower Zone BB", "Lower Zone CC"];
      return nonAlcoholZones.includes(seat.zone) ? " - No Alcohol" : "";
    }
    case "grey-cup": {
      const isNonAlcoholZone = seat.zone === 'Lower Zone L';
      return isNonAlcoholZone ? " (Family Zone - No Alcohol)" : '';
    }
  
    default:
      return "";
  }
};
